/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_Your_CodeInputs */

const en_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Referral Code`)
};

const es_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu código de referencia`)
};

const fr_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre code de parrainage`)
};

const de_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Empfehlungscode`)
};

const ja_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの紹介コード`)
};

const zh_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的推荐码`)
};

const ar_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمز الإحالة الخاص بك`)
};

const id_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode Referal Anda`)
};

const it_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Tuo Codice Invito`)
};

const ru_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш реферальный код`)
};

const pt_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu Código de Indicação`)
};

const ko_affiliate_your_code = /** @type {(inputs: Affiliate_Your_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나의 추천 코드`)
};

/**
* | output |
* | --- |
* | "Your Referral Code" |
*
* @param {Affiliate_Your_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_your_code = /** @type {((inputs?: Affiliate_Your_CodeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_Your_CodeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_your_code(inputs)
	if (locale === "es") return es_affiliate_your_code(inputs)
	if (locale === "fr") return fr_affiliate_your_code(inputs)
	if (locale === "de") return de_affiliate_your_code(inputs)
	if (locale === "ja") return ja_affiliate_your_code(inputs)
	if (locale === "zh") return zh_affiliate_your_code(inputs)
	if (locale === "ar") return ar_affiliate_your_code(inputs)
	if (locale === "id") return id_affiliate_your_code(inputs)
	if (locale === "it") return it_affiliate_your_code(inputs)
	if (locale === "ru") return ru_affiliate_your_code(inputs)
	if (locale === "pt") return pt_affiliate_your_code(inputs)
	return ko_affiliate_your_code(inputs)
});